import { useTranslation } from 'react-i18next';

import ReportsAccordion from '../General/ReportsAccordion';

import SanitarVulDataElement from './Elements/SanitarVulDataElement';
import TechVulsDataElement from './Elements/TechVulsDataElement';
import PracticeVulDataElement from './Elements/PracticeVulDataElement';

import { Vulnetability } from 'api/periodReports/type';

const VulnerabilityAccordion: React.FC<{ vul_data_list: Vulnetability[] }> = ({ vul_data_list }) => {
  const { t } = useTranslation();
  const TechVulsData = vul_data_list.filter(item => item.category === 'Технічний стан');
  const SanitarVulData = vul_data_list.filter(item => item.category === 'Санітарний стан');
  const PracticeVulData = vul_data_list.filter(item => item.category === 'Практика персоналу');

  return (
    <ReportsAccordion
      title={t('VulnerabilityList.accordion.accordion-title')}
      noDataText="No Vulnerability Data"
      key="vul_data_list"
    >
      <ReportsAccordion
        icon="ri-shield-flash-line"
        title={t('VulnerabilityList.accordion.accordion-inner-titles.tech')}
        noDataText={t('VulnerabilityList.accordion.accordion-inner-no-data.tech')}
        key="TechVulData"
        data={TechVulsData}
        mapElement={(data: Vulnetability) => <TechVulsDataElement data={data} />}
      />
      <ReportsAccordion
        icon="ri-recycle-fill"
        title={t('VulnerabilityList.accordion.accordion-inner-titles.sanitar')}
        noDataText={t('VulnerabilityList.accordion.accordion-inner-no-data.sanitar')}
        key="SanitarVulData"
        data={SanitarVulData}
        mapElement={(data: Vulnetability) => <SanitarVulDataElement data={data} />}
      />
      <ReportsAccordion
        icon="ri-headphone-line"
        title={t('VulnerabilityList.accordion.accordion-inner-titles.personal')}
        noDataText={t('VulnerabilityList.accordion.accordion-inner-no-data.personal')}
        key="PracticeVulData"
        data={PracticeVulData}
        mapElement={(data: Vulnetability) => <PracticeVulDataElement data={data} />}
      />
    </ReportsAccordion>
  );
};

export default VulnerabilityAccordion;
